module.exports = "https://assets.niwcorp.com/_next/static/images/esdLogo-ce5458f0e6ee1438d669ffed231915e6.jpg";